import { api } from '../../services/api'

export const create = (payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY', payload })
		return api
			.post(`/vacation/create`, payload)
			.then((response) => {
				// dispatch(showSuccess('Window has been disabled.'));
				dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: response.data })
			})
			.catch(() => {
				// dispatch(showError('An error occured while disabling window.'));
				dispatch({ type: 'UPDATE_FACILITY_FAIL' })
			})
	}
}

export const remove = (payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY', payload })
		return api
			.post(`/vacation/remove`, payload)
			.then((response) => {
				// dispatch(showSuccess('Window has been disabled.'));
				dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: response.data })
			})
			.catch(() => {
				// dispatch(showError('An error occured while disabling window.'));
				dispatch({ type: 'UPDATE_FACILITY_FAIL' })
			})
	}
}
